<template>
    <div class="select-gender">
        <label for="gender" class="d-none">Gender</label>
        <div class="styled-dropdown">
            <select id="gender" :class="errors ? 'is-invalid' : ''" :disabled="gender !== '' && !requireGender" class="form-control" required v-model="selectedGender">
                <option :hidden="!requireGender" :value="'u'">Please select an option</option>
                <option value="m" v-if="maleLabel">{{ maleLabel }}</option>
                <option value="f" v-if="femaleLabel">{{ femaleLabel }}</option>
            </select>
            <i class="fas fa-chevron-down"></i>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {
            'selectedGender': null
        };
    },

    props: {
        maleLabel: String,
        femaleLabel: String,
        gender: String,
        requireGender: Boolean,
        errors: Boolean,
    },

    watch: {
        selectedGender: function (gender) {
            // To test
            this.$root.$emit('genderSelected', gender);
            document.querySelector("input#gender").value = gender;

            if (document.querySelector("input#gender").value) {
                document.getElementById("step-2").classList.remove("d-none");
            }
        }
    },

    mounted() {
        this.selectedGender = document.querySelector("input#gender").value ? document.querySelector("input#gender").value : null;
    },

    methods: {
        //
    }
};
</script>
